import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSession } from "@user-management-context/primary/hooks/use-session";

export const OnboardingGate = () => {
  const { user } = useSession();
  const { pathname } = useLocation();

  if (!user) return null;

  const hasPendingOnboarding = user.roles.some(r => r.status === "pending_onboarding");
  const isOnboardingPath = pathname.startsWith("/onboarding");

  if (hasPendingOnboarding && !isOnboardingPath) {
    return <Navigate to="/onboarding" replace />;
  }

  if (!hasPendingOnboarding && isOnboardingPath) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
